import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section id="hero" className="w-full bg-cream py-12 md:py-16 px-4" data-id="element-194">
      <div className="max-w-6xl mx-auto" data-id="element-195">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-197">
            <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-navy mb-4 md:mb-6 leading-tight" data-id="element-198">
              Stop Spending Sunday Nights Planning. Start Spending Them Living.
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-charcoal mb-6 md:mb-8 leading-relaxed" data-id="element-199">
              The Mega Music Pack gives music educators a complete,
              ready-to-teach annual curriculum for Pre-K through Grade 12 — so
              your only job on Monday morning is to show up and teach.
            </p>
            <CtaButton data-id="element-200">GET INSTANT ACCESS →</CtaButton>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center mt-8 lg:mt-0" data-id="element-201">
            <img src="https://cdn.magicpatterns.com/uploads/7Wqh6nPDy9ddxsoQhhnDTr/IMG-M01.png" alt="Mega Music Pack curriculum materials" className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-lg shadow-2xl" data-id="element-202" />
          </motion.div>
        </div>
      </div>
    </section>;
}